module.exports = __webpack_public_path__ + "img/jieshu.4a6a338e.png";